import { TableModule } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxPermissionsModule } from 'ngx-permissions';
import { SplitterModule } from 'primeng/splitter';
import { DialogModule } from 'primeng/dialog';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TooltipModule } from 'primeng/tooltip';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CalendarModule } from 'primeng/calendar';
import { NgModule } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';
import { CarouselModule } from 'primeng/carousel';
import { ChipModule } from 'primeng/chip';
import { ChipsModule } from 'primeng/chips';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DropdownModule } from 'primeng/dropdown';

const ModulesList: any[] = [
  SplitterModule,
  DialogModule,
  NgSelectModule,
  CKEditorModule,
  CheckboxModule,
  AutoCompleteModule,
  TooltipModule,
  OverlayPanelModule,
  DragDropModule,
  RadioButtonModule,
  CalendarModule,
  TableModule,
  AccordionModule,
  NgxPermissionsModule,
  CarouselModule,
  ChipModule,
  ChipsModule,
  InputTextareaModule,
  ConfirmPopupModule,
  InputSwitchModule,
  DropdownModule,
];

@NgModule({
  declarations: [],
  imports: [...ModulesList],
  exports: [...ModulesList],
})
export class LeadPrimeNgModule {}
